/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IntercomProvider } from 'react-use-intercom';
import Header from 'components/header/Header';
import MainLayout from 'containers/layout/MainLayout';
import i18n from 'i18next';
import { ENGAGEMENT, EXPIRED_ENGAGEMENT, MOTIVATOR, PRELIMINARY_QUESTIONS, THANK_YOU } from 'constants/pageDictionary';
import { initiateMixpanel, initThirdPartyServices } from 'utils';
import ExpireEngagement from 'containers/engagement/Expire';
import * as pageActions from 'actions/pageActions';
import * as surveyActions from 'actions/surveyActions';
import * as timerActions from 'actions/timerActions';
import * as logoActions from 'actions/logoActions';
import { validate as uuidValidate } from 'uuid';
import IntercomChat from 'components/Intercom';
import Loading from '../components/loading/Loading';

const getBackgroundColor = (pageName) => {
    return pageName === MOTIVATOR ||
    pageName === THANK_YOU ||
    pageName === PRELIMINARY_QUESTIONS ? 'inherit' : '#1E3C4D';
};

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            showHeader: true,
            isSurveyActive: false
        };

        this.fetchData();
    }

    componentDidMount() {
        // Bounce-back timeout
        setTimeout(() => {
            this.setState({ isSurveyActive: true });
        }, 2500);
    }

    componentDidUpdate() {
        if (this.state.isSurveyActive && !this.isSurveyExpired()) {
            initThirdPartyServices();

            initiateMixpanel({
                email: this.props.userRespondentState.get('respondent_email'),
                accountId: this.props.userRespondentState.get('accountId'),
                firstName: this.props.userRespondentState.get('firstName'),
                lastName: this.props.userRespondentState.get('lastName')
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                { this.state.isLoading || !this.props.localeFilesFetched ?
                    <Loading /> :
                    <div
                        className='container-fluid no-select'
                        style={ { backgroundColor: getBackgroundColor(this.props.pageName) } }>
                        { this.state.showHeader ?
                            <div>
                                <Header />
                                <MainLayout />
                            </div> :
                            <ExpireEngagement />
                        }
                    </div>
                }
                {
                    (process.env.NODE_ENV !== 'development') &&
                        <IntercomProvider appId={ process.env.INTERCOM_APP_ID }>
                            <IntercomChat />
                        </IntercomProvider>
                }
            </React.Fragment>

        );
    }

    fetchData = () => {
        const path = window.location.pathname.split('/');
        const type = path[1] === 'engagement' ? 'engagement/questions' : 'survey';
        const token = path[path.length - 1];

        // Redirect to error page if invalid token
        if (!uuidValidate(token)) {
            this.props.actions.goToPage(EXPIRED_ENGAGEMENT, {
                message: i18n.t('welcome.the_link_you_clicked_may_be_broken'),
                title: i18n.t('welcome.page_not_found')
            });

            this.setState({ isLoading: false });

            return;
        }

        this.props.actions.getSurvey(type, token).then(async (isRedirected) => {
            if (this.isSurveyExpired()) {
                this.setState({ showHeader: false, isLoading: false });

                return;
            }

            if (type === 'engagement/questions') {
                this.props.actions.updateEngagementSurveyToken(window.location.pathname.split('/')[2]);
                this.props.actions.goToPage(ENGAGEMENT);
            }

            if (!isRedirected) {
                this.setState({ isLoading: false });
            }
        }).catch(() => {
            if (this.isSurveyExpired()) {
                this.setState({ showHeader: false });
            }

            this.setState({ isLoading: false });
        });

        this.props.actions.getSurveyOptions(token);
        this.props.actions.getRespondentAges();
        this.props.actions.getRespondentGenders();
    };

    startMotivatorAssessment = async () => {
        return new Promise(async (resolve) => {
            await this.props.actions.startSurvey();
            await this.props.actions.startTimer(new Date());
            await this.props.actions.goToPage(MOTIVATOR);

            resolve();
        });
    };

    isSurveyExpired = () => {
        return this.props.pageName === EXPIRED_ENGAGEMENT;
    }
}

App.propTypes = {
    actions: PropTypes.object,
    pageName: PropTypes.string,
    userRespondentState: PropTypes.object
};

App.defaultProps = {
    actions: null,
    pageName: null,
    userRespondentState: null
};
const mapStateToProps = state => ({
    pageName: state.pageReducer.get('goToPage'),
    localeFilesFetched: state.changeLanguageReducer.get('localeFilesFetched'),
    userRespondentState: state.respondentNameReducer
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Object.assign({}, surveyActions, pageActions, timerActions, logoActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
